import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import { API } from "../../helper/Api";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { RotatingLines } from "react-loader-spinner";
import Footer from "../common/Footer";
import Header from "../common/Header";
import SessionHandler from "../common/SessionHandler";
import { useNavigate } from 'react-router-dom';

export default function Employee({ sidebarCollapsed }) {
  const [items, setItems] = useState([]);
  const [page, setPage] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [pending, setPending] = useState(true);
  const navigate = useNavigate();

  

  

  useEffect(() => {
    console.log("new@@@",API.getSts());
    employeeList();
  }, [page]);

  const employeeList = () => {
    const getSession = process.env.REACT_SESSION;
    console.log("session status->",getSession);
    setPending(true);

    API.getEmployee({ page })
      .then((datas) => {
        const items = datas.ApiDocument.Response.Employees.flatMap(
          (Employees) => Employees
        );
        const totalRecords = datas.ApiDocument.TotalRecords;
        setItems(items);
        setTotalRecords(totalRecords);
        setPending(false);
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    if (items.length > 0) {
     return  API.DataTableScript();
    }
  }, [items]);

  const handleRowClicked = (row) => {
    setPage(row);
  };

  const columns = [
    {
      name: "First Name",
      selector: (row) => row.FirstName,
      sortable: true,
    },
    { name: "Last Name", selector: (row) => row.LastName, sortable: true },
    { name: "Email", selector: (row) => row.EMail1, sortable: true },
    { name: "Login", selector: (row) => row.LoginName, sortable: true },
    {
      name: "Action",
      cell: (row) => (
        <a href="#" value={row.StyleNo}>
          Edit
        </a>
      ),
      sortable: true,
    },
  ];

  
  return (
    <>
    
      <div class="container-fluid page-body-wrapper">
            <div class="main-panel">
        <div class="content-wrapper">
        <div >
          {/* <DataTable
            columns={columns}
            data={items}
            pagination
            paginationServer={true}
            onChangePage={handleRowClicked}
            paginationTotalRows={totalRecords}
            paginationPerPage={10}
            progressPending={pending}
          /> */}
<div class="Card_contend">
            {pending ? (
              <div className="loader">
                <RotatingLines
                  visible={true}
                  height="96"
                  width="96"
                  strokeColor="grey"
                  strokeWidth="2"
                  animationDuration="0.75"
                  ariaLabel="rotating-lines-loading"
                />
              </div>
            ) : (
              <div>
                {!pending ? ( 
                  <table id="myTable1" className="row-border">           
                      <thead>
                        <tr>
                        <th style={{fontWeight:"bold",color: "#665d5d"}}>First Name</th>
                        <th style={{fontWeight:"bold",color: "#665d5d"}}>Last Name</th>
                        <th style={{fontWeight:"bold",color: "#665d5d"}}>Email</th>
                        <th style={{fontWeight:"bold",color: "#665d5d"}}>Login</th>
                        <th style={{fontWeight:"bold",color: "#665d5d"}}>Action</th>
                        </tr>
                      </thead>
                        <tbody>
                          {items.map((item, index) => (
                            <tr>
                              <td>{item.FirstName ? item.FirstName : ''}</td>
                              <td>{item.LastName ? item.LastName : ''}</td>
                              <td>{item.EMail1 ? item.EMail1 : ''}</td>
                              <td>{item.LoginName ? item.LoginName : ''}</td>
                              <td>{item.StyleNo ? item.StyleNo : ''}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                ): null} 
              </div>
            )}
            
            </div>



        </div>
 
        </div>
        </div>
        </div>
    
      
    </>
  );
}
